import React, { Component } from 'react';
import { connect } from 'react-redux';

import NavBar from '../../../_components/common/Navbar';
import Footer from '../../../_components/common/Footer';

import { getAllotmentSummaryAction } from '../../../_actions';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';
import TableNew from '../../../_components/common/TableNew';
import downloadCsv from 'download-csv';


class AllotmentSummary extends Component {
    state = {
        AllotmentSummaryData: '',
        filteredData: [],
        selectedFilter: '',
        inputFilter: ''
    }
    componentDidMount() {
        const { dispatch } = this.props;

        const usertype = localStorage.getItem('usertype');

        this.props.dispatch(getAllotmentSummaryAction.getAllotmentSummaryHandler((data) => {
            this.setState({
                filteredData: data,
                selectedFilter: usertype.includes('seller_admin') ? 'organisation_assessment_credit__organisation__organisation_name' : 'organisation_assessment_credit__instrument__instrument_name'
            }, () => {

            })
        }))
    }

    handleFilterSelect = e => {
        this.setState({
            selectedFilter: e.target.value
        })
    }

    searchStringInArray(str, strArray) {
        for (var j = 0; j < strArray.length; j++) {
            if (strArray[j].match(str)) return j;
        }
        return -1;
    }

    handleFilterInput = e => {

        let typedText = e.target.value
        let allotmentData = this.props.allotmentSummaryResponse.user_credits_list

        let filteredData = []


        if (typedText.length !== 0) {
            filteredData = allotmentData.filter(
                (data) => {
                    if (data[this.state.selectedFilter] !== null) {
                        return (data[this.state.selectedFilter].toLowerCase().indexOf(typedText.toLowerCase()) !== -1);
                    }
                }
            )
        } else {
            filteredData = this.props.allotmentSummaryResponse.user_credits_list
        }


        this.setState({
            inputFilter: e.target.value,
            filteredData: filteredData
        })
    }

    onClickDownloadCSV = (allotmentSummaryResponse) => {

        const tableData = [];

        !localStorage.getItem('usertype').includes('seller_admin') ?
            allotmentSummaryResponse.user_credits_list.map(
                (data, i) => {
                    tableData.push({
                        'INSTRUMENT': data.organisation_assessment_credit__instrument__instrument_name,
                        'TOTAL CREDITS': data.total_credits,
                        'ALLOTTED CREDITS': data.sold_assigned_credits,
                        'AVAILABLE CREDITS': data.unsold_credits
                    })
                }
            )
            : allotmentSummaryResponse.user_credits_list.map(
                (data, i) => {
                    tableData.push({

                        'ORGANISATION NAME': data.organisation_assessment_credit__organisation__organisation_name,
                        'INSTRUMENT': data.organisation_assessment_credit__instrument__instrument_name,
                        'TOTAL CREDITS': data.total_credits,
                        'SOLD': data.sold_credits,
                        'UNSOLD': data.unsold_credits,
                        'SOLD-ASSIGNED': data.credit_in_use,
                        'SOLD-UNASSIGNED': data.sold_credits - data.credit_in_use
                    })
                }
            );

        const columns = !localStorage.getItem('usertype').includes('seller_admin') ? {
            'INSTRUMENT': 'INSTRUMENT',
            'TOTAL CREDITS': 'TOTAL CREDITS',
            'ALLOTTED CREDITS': 'ALLOTTED CREDITS',
            'AVAILABLE CREDITS': 'AVAILABLE CREDITS'
        } : {

            'ORGANISATION NAME': 'ORGANISATION NAME',
            'INSTRUMENT': 'INSTRUMENT',
            'TOTAL CREDITS': 'TOTAL CREDITS',
            'SOLD': 'SOLD',
            'UNSOLD': 'UNSOLD',
            'SOLD-ASSIGNED': 'SOLD-ASSIGNED',
            'SOLD-UNASSIGNED': 'SOLD-UNASSIGNED'
        }
        downloadCsv(tableData, columns, `allotmentSummary.csv`);
    }

    render() {
        const { allotmentSummaryResponse, getAllotmentSummaryLoading } = this.props;
        const data = this.state.AllotmentSummaryData === '' && !getAllotmentSummaryLoading ? allotmentSummaryResponse.user_credits_list : this.state.AllotmentSummaryData;

        const usertype = localStorage.getItem('usertype');

        const filteredData = this.state.AllotmentSummaryData === '' && !getAllotmentSummaryLoading ? allotmentSummaryResponse.user_credits_list.map(
            (element, i) => {
                element.organisation_assessment_credit__organisation__organisation_name = element.organisation_assessment_credit__organisation__organisation_name;
                element.organisation_assessment_credit__instrument__instrument_name = element.organisation_assessment_credit__instrument__instrument_name;
                element.total_credits = element.sold_credits + element.unsold_credits;
                element.sold_credits = element.sold_credits;
                element.unsold_credits = element.unsold_credits;
                element.sold_assigned_credits = element.credit_in_use;
                element.sold_unassigned_credits = element.sold_credits - element.credit_in_use;
            }) : this.state.AllotmentSummaryData

        const sellerAdminColumn = [{
            name: 'ORGANISATION NAME',
            key: 'organisation_assessment_credit__organisation__organisation_name',
            linkActive: false,
            link: '',
        }, {
            name: 'INSTRUMENT',
            key: 'organisation_assessment_credit__instrument__instrument_name',
            linkActive: false,
            link: '',
        }, {
            name: 'TOTAL CREDITS',
            key: 'total_credits',
            linkActive: false,
            link: '',
        }, {
            name: 'SOLD',
            key: 'sold_credits',
            linkActive: false,
            link: '',
        }, {
            name: 'UNSOLD',
            key: 'unsold_credits',
            linkActive: false,
            link: '',
        }, {
            name: 'SOLD - ASSIGNED',
            key: 'sold_assigned_credits',
            linkActive: false,
            link: '',
        }, {
            name: 'SOLD - UNASSIGNED',
            key: 'sold_unassigned_credits',
            linkActive: false,
            link: '',
        }]

        const orgAdminColumn = [{
            name: 'INSTRUMENT',
            key: 'organisation_assessment_credit__instrument__instrument_name',
            linkActive: false,
            link: '',
        }, {
            name: 'TOTAL CREDITS',
            key: 'total_credits',
            linkActive: false,
            link: '',
        }, {
            name: 'ALLOTTED CREDITS',
            key: 'sold_credits',
            linkActive: false,
            link: '',
        }, {
            name: 'AVAILABLE CREDITS',
            key: 'unsold_credits',
            linkActive: false,
            link: '',
        }]

        return (
            <div>
                <NavBar />
                <div className="container custom-container my-5" >
                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'ALLOTMENT SUMMARY'
                                }
                            ]}
                        />
                    </div>
                    <div className="bg-green rounded-top mb-3">
                        <p className="text-center text-uppercase py-2 text-white mb-0">SELLER DETAILS</p>
                        <div className="col-xs-12" style={{ background: 'rgb(245, 245, 245)' }}>
                            <p className="pt-1 pl-2 pb-2 mb-1">Seller : {
                                !getAllotmentSummaryLoading &&
                                allotmentSummaryResponse.user_details.seller_name
                            }
                            </p>
                            {
                                (!usertype.includes('seller_admin') && usertype.includes('organisation_admin')) &&
                                <p className="pt-1 pl-2 pb-2 mb-1">Organization : {
                                    !getAllotmentSummaryLoading &&
                                    allotmentSummaryResponse.user_details.organisation_name
                                }
                                </p>
                            }

                        </div>
                    </div>
                    <div>
                        <div className="bg-green rounded-top d-flex flex-row flex-wrap justify-content-center align-items-center position-relative">
                            <div>
                                <p className="text-center text-uppercase py-2 text-white mb-0"> ALLOTMENT SUMMARY</p>
                            </div>
                            <div className=" mr-md-3 align-items-center h-100 position-absolute" style={{ right: '0', top: '0', display: 'flex' }}>
                                <button onClick={() => this.onClickDownloadCSV(allotmentSummaryResponse)} className="ml-1 btn btn-sm btn-red"><small>Download as CSV</small></button>
                            </div>
                        </div>
                        <div style={{ backgroundColor: '#5e5e5e', padding: '1rem 0' }}>

                            <div style={{ display: 'flex' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 30, width: 50, borderRight: '1px solid #fff' }}>
                                    <i className="fas fa-search text-white"></i>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '0 10px' }}>
                                    <div style={{ padding: '0 5px' }}>
                                        <select
                                            style={{
                                                marginLeft: 10,
                                                backgroundColor: 'transparent',
                                                height: 30,
                                                color: '#eee',
                                                boxShadow: 'none',
                                                borderRadius: 0,
                                                border: '1px solid #eee',
                                                textIndent: '0.01px',
                                                padding: '.3rem 1.8rem .3rem .3rem'
                                            }}
                                            onChange={this.handleFilterSelect}
                                            value={this.state.selectedFilter}
                                        >
                                            {
                                                (usertype.includes('seller_admin')) ?
                                                    <option className="bg-gray" value="organisation_assessment_credit__organisation__organisation_name" >Organisation Name</option>
                                                    :
                                                    null
                                            }
                                            <option
                                                className="bg-gray"
                                                value="organisation_assessment_credit__instrument__instrument_name"
                                                disabled={!usertype.includes('seller_admin')}
                                            >
                                                Instrument
                                            </option>

                                        </select>
                                    </div>
                                    <div style={{ padding: '0 5px' }}>
                                        <input style={{ padding: '2px' }} value={this.state.inputFilter} type="text" placeholder='Search...' onChange={this.handleFilterInput} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <TableNew
                                data={this.state.filteredData}
                                columns={usertype.includes('seller_admin') ? sellerAdminColumn : orgAdminColumn}
                                showSlNo="true"
                            />
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {

    const { getAllotmentSummaryLoading } = state.getAllotmentSummary;
    const allotmentSummaryResponse = (!getAllotmentSummaryLoading) ? state.getAllotmentSummary.data.data.message : '';
    return {
        getAllotmentSummaryLoading,
        allotmentSummaryResponse,
    }
}

export default connect(mapStateToProps)(AllotmentSummary);



// WEBPACK FOOTER //
// ./src/_pages/Admin/AllotmentSummary/index.js